import {
    Elements,
    PaymentElement,
    useElements,
    useStripe,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { STRIPE_PUBLIC_KEY } from '~/lib/Payments.js';
import { useContext, useState } from 'react';
import { ThemeContext } from '~/lib/ThemeContext';
import Loading from '~/components/Loading';
import usePublicPostApi from '~/public/lib/usePublicPostApi.js';
import useSharedPostApi from '~/lib/useSharedPostApi.js';
const stripeInstances = {};

function getStripe(accountId) {
    if (!accountId) {
        return null;
    }

    if (!stripeInstances[accountId]) {
        stripeInstances[accountId] = loadStripe(STRIPE_PUBLIC_KEY, {
            stripeAccount: accountId,
        });
    }

    return stripeInstances[accountId];
}

const StripeForm = ({
    returnUrl,
    paymentElementContainerClassName,
    paymentBtnLabel,
    type,
    id,
    paymentOptions,
    //isSetupIntent,
}) => {
    const stripe = useStripe();
    const elements = useElements();

    const { save: saveStripePaymentIntent, isSaving } = useSharedPostApi(
        `/payments/stripe-payment-intent`,
    );

    const [errorMessage, setErrorMessage] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const themeContext = useContext(ThemeContext);
    const isThemed = !!themeContext && Object.keys(themeContext).length > 0;

    async function submit(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        if (!stripe || !elements) {
            return;
        }

        setIsSubmitting(true);

        const { error: submitError } = await elements.submit();
        if (submitError) {
            setErrorMessage(submitError.message);
            setIsSubmitting(false);
            return;
        }

        let error = null;

        // TODO -- server side call to get payment intent!
        const paymentIntent = await saveStripePaymentIntent({
            intentToken: paymentOptions?.intentToken,
        });

        const isSetupIntent = paymentIntent?.object === 'setup_intent';

        if (isSetupIntent) {
            ({ error } = await stripe.confirmSetup({
                //`Elements` instance that was used to create the Payment Element
                elements,
                clientSecret: paymentIntent.client_secret,
                confirmParams: {
                    return_url: returnUrl,
                },
            }));
        } else {
            ({ error } = await stripe.confirmPayment({
                //`Elements` instance that was used to create the Payment Element
                elements,
                clientSecret: paymentIntent.client_secret,
                confirmParams: {
                    return_url: returnUrl,
                },
            }));
        }

        setIsSubmitting(false);

        if (error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setErrorMessage(error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
    }

    const isAdminApp = false;

    return (
        <form onSubmit={submit}>
            <div className={paymentElementContainerClassName}>
                <PaymentElement />
            </div>

            {!elements && (
                <div className="min-h-32 text-2xl">
                    <Loading />
                </div>
            )}

            {!!errorMessage && (
                <div className="text-red-600 my-2">{errorMessage}</div>
            )}
            <button
                className={`${!isThemed ? 'btn-save' : 'form-button'} mt-2`}
                disabled={!stripe}
            >
                {isSubmitting ? 'Paying...' : paymentBtnLabel || 'Pay Now'}
            </button>
        </form>
    );
};

const StripePaymentForm = ({
    type,
    id,
    paymentSettings,
    paymentBtnLabel,
    paymentElementContainerClassName,
}) => {
    const { color } = useContext(ThemeContext);

    let appearance = {};
    if (color) {
        appearance = {
            variables: {
                colorPrimary: color,
            },
        };
    }

    const options = {
        // pass the client secret from  the previous step
        //clientSecret: paymentSettings?.paymentIntent?.client_secret,
        ...(paymentSettings?.paymentIntent || {}),
        // Fully customizable with the Appearance API
        appearance: appearance,
    };

    return (
        <div key={paymentSettings?.paymentIntent?.amount}>
            <Elements
                stripe={getStripe(paymentSettings?.accountId)}
                options={options}
            >
                <StripeForm
                    returnUrl={paymentSettings?.returnUrl}
                    paymentBtnLabel={paymentBtnLabel}
                    paymentElementContainerClassName={
                        paymentElementContainerClassName
                    }
                    paymentOptions={paymentSettings?.paymentIntent}
                    type={type}
                    id={id}
                    // isSetupIntent={
                    //     paymentSettings?.paymentIntent?.object ===
                    //     'setup_intent'
                    // }
                />
            </Elements>
        </div>
    );
};

export default StripePaymentForm;
